/**
 * NOTE: CODEGEN IS USED IN THIS FILE. Careless manual edits may be lost.
 *
 * server/tools/syncDirs.ts keeps this file in sync with:
 *   server/src/shared/strapiTypes/common/Blocks.ts
 */

/**
 * NOTE: CODEGEN IS USED IN THIS FILE. Careless manual edits may be lost.
 *
 * server/tools/syncDirs.ts keeps this file in sync with:
 *   strapi/types/common/Blocks.ts
 */

// Interface automatically generated by schemas-to-ts

export enum TextBlockType {
	TEXT = "text",
	HEADING = "heading",
	LIST = "list",
	LIST_ITEM = "list-item",
	PARAGRAPH = "paragraph",
	LINK = "link",
	QUOTE = "quote",
	CODE = "code",
}
export interface TextBlock {
	type: TextBlockType.TEXT;
	text: string;
	italic?: boolean;
	bold?: boolean;
	underline?: boolean;
	strikethrough?: boolean;
	code?: boolean;
}

export interface AbstractParentBlock {
	type: string;
	children: Block[];
}

export interface HeadingBlock extends AbstractParentBlock {
	type: TextBlockType.HEADING;
	level: 1 | 2 | 3 | 4 | 5 | 6;
}

export interface ListBlock extends AbstractParentBlock {
	type: TextBlockType.LIST;
	format: "unordered" | "ordered";
}

export interface ListItemBlock extends AbstractParentBlock {
	type: TextBlockType.LIST_ITEM;
}

export interface ParagraphBlock extends AbstractParentBlock {
	type: TextBlockType.PARAGRAPH;
}

export interface LinkBlock extends AbstractParentBlock {
	type: TextBlockType.LINK;
	url: string;
}

export interface QuoteBlock extends AbstractParentBlock {
	type: TextBlockType.QUOTE;
}

export interface CodeBlock extends AbstractParentBlock {
	type: TextBlockType.CODE;
}

export type Block =
	| TextBlock
	| HeadingBlock
	| ListBlock
	| ListItemBlock
	| ParagraphBlock
	| LinkBlock
	| QuoteBlock
	| CodeBlock;

export type Blocks = Block[];
